/* eslint-disable func-names */
import React, { useEffect, useState, useCallback } from 'react';
import { Container } from 'reactstrap';
import { useRouteMatch } from 'react-router-dom';
import { Timer } from 'react-countdown-clock-timer';
import { differenceInSeconds } from 'date-fns';
import Modal from '../../utils/modalOfBet/index';

import 'react-toastify/dist/ReactToastify.min.css';

import api from '../../services/api';

import { Header, Footer, Main, TableOfKills } from './styles';

import logoImg from '../../assets/logo.svg';

interface DataOfPlayer {
  user: string;
  alive: string;
  number: number;
  ip: string;
}

interface DataOfBounty {
  [i: string]: string;
  id: string;
  killer: string;
  victim: string;
  rollOfVictim: string;
  rollOfKiller: string;
}

interface DataOfBounty {
  bountyId: string;
  username: string;
}

interface NumberOfKills {
  username: string;
  numberOfKills: number;
  ghost: boolean;
}

interface BountyParams {
  bountyId: string;
}

const BountyPage: React.FC = () => {
  const { params } = useRouteMatch<BountyParams>();
  // First Step
  const [arrayOfListOfKills, setArrayOfListOfKills] = useState<DataOfBounty[]>(
    [],
  );
  const [arrayOfRegistred, setArrayOfRegistred] = useState<DataOfPlayer[]>([]);
  const [arrayOfTimes, setArrayOfTimes] = useState<number[]>([]);
  const [timeOfRegistration, settimeOfRegistration] = useState<number>(0);

  const [arrayOfNumberOfKills, setArrayOfNumberOfKills] = useState<
    NumberOfKills[]
  >([]);

  const [dateOfStart, setDateOfStart] = useState<string>('');
  const [dateOfEnd, setDateOfEnd] = useState<string>('');

  const updateDatas = useCallback(async () => {
    // First Step
    api
      .get(`/bountyRoll/JohnAdminOfWorkInFirstBounty/${params.bountyId}`)
      .then((response) => {
        if (response.data[0].listOfBounty)
          setArrayOfListOfKills(JSON.parse(response.data[0].listOfBounty));
        if (response.data[0].usernames)
          setArrayOfRegistred(JSON.parse(response.data[0].usernames));
        setArrayOfTimes([
          Number(response.data[0].startRegistration),
          Number(response.data[0].startBounty),
          Number(response.data[0].ended),
        ]);

        const timeInSecond = differenceInSeconds(
          new Date(Number(response.data[0].startBounty)),
          new Date(Date.now()),
        );

        if (timeInSecond > 0) {
          settimeOfRegistration(timeInSecond);
        }
      });
  }, [params.bountyId]);

  useEffect(() => {
    updateDatas();
  }, [updateDatas]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const count: any = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arrayOfListOfKills.forEach(function (i: any) {
      if (i.ghostKill) {
        count[`${i.killer}(ghost)`] = (count[`${i.killer}(ghost)`] || 0) + 1;
      } else {
        count[i.killer] = (count[i.killer] || 0) + 1;
      }
    });
    const countKeys = Object.keys(count);
    const countValues: number[] = Object.values(count);
    const arrayWithKeysValues = countKeys.map((key: string, index) => {
      if (key.includes('(ghost)')) {
        return {
          username: key,
          numberOfKills: countValues[index],
          ghost: true,
        };
      }
      return { username: key, numberOfKills: countValues[index], ghost: false };
    });
    const arrayOrderned = arrayWithKeysValues.sort((a, b) => {
      return b.numberOfKills - a.numberOfKills;
    });
    setArrayOfNumberOfKills(arrayOrderned);
  }, [arrayOfListOfKills]);

  useEffect(() => {
    setDateOfStart(new Date(arrayOfTimes[1]).toUTCString());
    setDateOfEnd(new Date(arrayOfTimes[2]).toUTCString());
  }, [arrayOfTimes]);

  return (
    <>
      <Header>
        <Container className="container">
          <img src={logoImg} alt="Bitsler" />
          <div>
            <Modal
              buttonLabel="Base Bet"
              className="baseBet"
              modalTitle="Base Bet"
              bountyId={params}
            />
          </div>
        </Container>
      </Header>

      <Main>
        <Container className="container">
          <h2>First Round</h2>
        </Container>
        <Container className="container">
          <span>
            <h4>Time to Registration</h4>
            <>
              <Timer durationInSeconds={timeOfRegistration} formatted />
            </>
          </span>
          <span>
            <h4>Date and Time to Start</h4>
            <p>{dateOfStart}</p>
          </span>
          <span>
            <h4>Date and Time to Finish</h4>
            <p>{dateOfEnd}</p>
          </span>
        </Container>
      </Main>

      <TableOfKills>
        <Container className="container">
          <div>
            <table>
              <thead>
                <tr>
                  <th>BET ID</th>
                  <th>KILLER</th>
                  <th>VICTIM</th>
                </tr>
              </thead>
              <tbody>
                {arrayOfListOfKills.map((bountyKill) => (
                  <tr key={bountyKill.id}>
                    <>
                      <td>({bountyKill.id})</td>
                      <td>
                        ({bountyKill.rollOfKiller} {bountyKill.killer})
                      </td>
                      <td>({bountyKill.victim})</td>
                    </>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div>
            <table>
              <thead>
                <th>USERNAME</th>
                <th>NUMBER</th>
                <th>ALIVE</th>
                <th>IP</th>
              </thead>
              <tbody>
                {arrayOfRegistred.map((bountyKill) => (
                  <tr key={bountyKill.number}>
                    <>
                      <td>@{bountyKill.user}</td>
                      <td>({bountyKill.number})</td>
                      <td>({bountyKill.alive && 'alive'})</td>
                      <td>({bountyKill.ip})</td>
                    </>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div>
            <table>
              <thead>
                <th>List Of Kills</th>
              </thead>
              <tbody>
                {arrayOfNumberOfKills.map((numberOfKill) => (
                  <>
                    <>
                      {!numberOfKill.ghost && (
                        <>
                          <tr key={numberOfKill.username}>
                            <td>
                              @{numberOfKill.username} (
                              {numberOfKill.numberOfKills} (kill(s)
                            </td>
                          </tr>
                        </>
                      )}
                    </>
                  </>
                ))}
              </tbody>
            </table>
          </div>
          <div>
            <table>
              <thead>
                <th className="yellow">Ghost Kill</th>
              </thead>
              <tbody>
                {arrayOfNumberOfKills.map((numberOfKill) => (
                  <>
                    <>
                      {numberOfKill.ghost && (
                        <tr key={numberOfKill.username}>
                          <td className="yellow">
                            @{numberOfKill.username.replace('(ghost)', '')} (
                            {numberOfKill.numberOfKills} (kill(s)
                          </td>
                        </tr>
                      )}
                    </>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </Container>
      </TableOfKills>

      <Footer />
    </>
  );
};

export default BountyPage;
